import React, { useEffect, useState } from "react";
import { Pause, Play, Trash } from "@phosphor-icons/react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";

export function PauseBar({ channel }) {
  const [paused, setPaused] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get(`/marketing/${channel}/pause`).then((r) => setPaused(r.data.paused)).catch(() => {}); }, [channel]);
  const run = async (fn, msg) => {
    setBusy(true);
    try { await fn(); toast.success(msg); } catch (e) { toast.error(apiError(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  const toggle = () => run(async () => setPaused((await api.put(`/marketing/${channel}/pause`, { paused: !paused })).data.paused), paused ? "Sending resumed" : "Sending paused");
  const purge = () => {
    if (!window.confirm(`Stop all ${channel.toUpperCase()} sending and permanently delete every ${channel.toUpperCase()} campaign and message?`)) return;
    run(async () => { const { data } = await api.post(`/marketing/${channel}/purge`); setPaused(true); return data; }, "Stopped and deleted");
  };
  if (paused === null) return null;
  return (
    <div className={`mb-4 flex flex-wrap items-center gap-3 rounded-2xl border px-5 py-3.5 ${paused ? "border-red-300 bg-red-50" : "border-slate-200 bg-white"}`} data-testid={`mk-pausebar-${channel}`}>
      <span className={`h-2.5 w-2.5 rounded-full ${paused ? "bg-red-500" : "bg-emerald-500 animate-pulse"}`} />
      <p className="text-sm font-semibold text-slate-800 flex-1" data-testid={`mk-pause-status-${channel}`}>
        {paused ? `${channel.toUpperCase()} marketing is paused — nothing will be sent until you resume.` : `${channel.toUpperCase()} marketing is active.`}
      </p>
      <Button size="sm" variant={paused ? "default" : "outline"} disabled={busy} onClick={toggle} data-testid={`mk-pause-toggle-${channel}`}>
        {paused ? <><Play size={14} weight="fill" className="mr-1.5" />Resume sending</> : <><Pause size={14} weight="fill" className="mr-1.5" />Pause sending</>}
      </Button>
      <Button size="sm" variant="outline" disabled={busy} onClick={purge} className="text-red-600 border-red-200 hover:bg-red-50" data-testid={`mk-purge-${channel}`}>
        <Trash size={14} className="mr-1.5" />Stop & delete all data
      </Button>
    </div>
  );
}
